import { event, GtagEvent } from "./event";

export interface JoinGroup extends GtagEvent {
    group_id:string;
}
export const join_group = ($_:JoinGroup) => event('join_group',$_);